import "twin.macro";

import { Search } from "lucide-react";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { LoadingSpinner } from "./LoadingIndicator";

const SearchBar = ({
  search,
  setSearch,
  isRefetching,
}: {
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  isRefetching?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div tw="relative md:(w-1/4) sm:(w-1/2) w-full  text-gray-500">
      <label htmlFor="search" tw="sr-only">
        {t("search")}
      </label>
      <div tw="relative rounded-xl shadow">
        <div tw="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          {isRefetching ? (
            <LoadingSpinner
              tw="h-5 w-5 text-on-surface/60"
              aria-hidden="true"
            />
          ) : (
            <Search tw="h-5 w-5 text-on-surface/60" aria-hidden="true" />
          )}
        </div>
        <input
          type="search"
          name="search"
          tw="block w-full rounded-xl border-0 py-1.5 pl-10 bg-surface/50 text-gray-800 placeholder:text-gray-500 focus:(ring-2 ring-inset ring-primary-700) sm:(text-sm leading-6)"
          placeholder={t("search")}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>
    </div>
  );
};

export default SearchBar;
